import { useState } from 'react';
import { endOfMonth, startOfMonth } from 'date-fns';

import SemesterChart from './SemesterChart';
import DailyNewCustomers from './DailyNewCustomers';
import DashboardCard from '../components/DashboardCard';
import PeriodSelector from '../components/PeriodSelector';
import DashboardOrdersExportButton from '../components/DashboardOrdersExportButton';

import { Divider, Grid, Stack, Typography } from '@mui/material';

const SEMESTER_OPTIONS = [
    { value: 'first', label: '1er semestre' },
    { value: 'second', label: '2do semestre' }
];

const YearNewClients = ({
    firstSemester, secondSemester,
    totalNewClients, customers, today
}) => {
    const [semester, setSemester] = useState('first');
    const isFirstSemester = semester === 'first';
    const label = isFirstSemester ? 'Primer semestre' : 'Segundo semestre';
    const data = isFirstSemester ? firstSemester : secondSemester;
    const year = today.getFullYear();
    const startMonth = isFirstSemester ? 0 : 6;
    const endMonth = isFirstSemester ? 5 : 11;

    return (
        <Grid container spacing={4}>
            <Grid item xl={7} lg={7} md={12} sm={12} xs={12}>
                <DashboardCard
                    className="clientes-nuevos-card"
                    title={`Clientes nuevos (${year})`}
                    action={
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <DashboardOrdersExportButton
                                reportType="new_customers"
                                range={{
                                    startDate: startOfMonth(new Date(year, startMonth, 1)),
                                    endDate: endOfMonth(new Date(year, endMonth, 1))
                                }}
                                filename={`pedidos_clientes-nuevos_${semester}-semestre_${year}.csv`}
                            />
                            <PeriodSelector
                                menuId="new-customers-semester-menu"
                                value={semester}
                                options={SEMESTER_OPTIONS}
                                onChange={setSemester}
                                ariaLabel="Seleccionar semestre de clientes nuevos"
                            />
                        </Stack>
                    }
                >
                    <SemesterChart label={label} data={data} />
                    <Divider sx={{ my: 3 }} />
                    <Typography variant="h6" color="text.secondary" align="center">
                        {totalNewClients}
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ fontWeight: 'bold' }}
                        align="center"
                    >
                        Total clientes nuevos
                    </Typography>
                </DashboardCard>
            </Grid>
            <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
                <DailyNewCustomers customers={customers} today={today} />
            </Grid>
        </Grid>
    );
};

export default YearNewClients;
